import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/layout/index.vue'

import { menuList } from './routes'
import { getMenuList } from '@/utils/common'

let actionRouteList = []  //一些操作跳转的路由，业务平台无法设置这些权限


const routesList = getMenuList(menuList, actionRouteList)

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/welcome',
    component: HomeView,
    children: [
      {
        name: 'welcome',
        path: '/welcome',
        component: () => import('@/views/welcome.vue'),
        meta: {
          title: '首页',
          keepAlive: true,
          icon: 'icon-shezhi',
          hidden: true
        }
      },    
      ...routesList
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => HomeView,
    redirect: '/404/no_page',
    children: [
      {
        path: '/404/no_page',
        name: '404',
        component: () => import('@/views/404.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404'
  },
  {
    path: '/empty',
    component: () => import('@/views/empty.vue')
  }
]

const router = createRouter({
  // 👇 __MICRO_APP_BASE_ROUTE__ 为micro-app传入的基础路由
  history: createWebHistory((window as any).__MICRO_APP_BASE_ROUTE__ || process.env.BASE_URL),
  // history: createWebHashHistory((window as any).__MICRO_APP_BASE_ROUTE__ || process.env.BASE_URL),
  routes,
})


// router.beforeEach((to,from, next) => {

// })

export default router
